<template>
  <button
      @click="$emit('click', $event)"
      class="wt-button"
      :class="classObj"
      :disabled="disabled"
      :title="title"
  >
    <wt-google-like-loader
        v-if="processing"
        class="-default"
    />
    <i
        v-else-if="icon"
        :class="['wticon', icon]"
    />

    <span
        v-if="text"
        v-text="text"/>

    <slot name='suffix'></slot>
  </button>

</template>

<script>
import wtGoogleLikeLoader from './wtGoogleLikeLoader.component.vue';
export default {
  name: 'wtButton',
  components: {
    wtGoogleLikeLoader,
  },
  props: {
    type: {
      type: String,
      default: 'primary',
    },

    title: {
      type: String,
      default: '',
    },

    text: {
      type: String,
      default: '',
    },

    circle: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    icon: {
      type: String,
      default: '',
    },

    iconPosition: {
      type: String,
      default: 'left',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    processing: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    classObj() {
      return [
        {
          [this.type]: true,
          reverse: this.iconPosition === 'right',
          glyph: this.icon && _.isEmpty(this.text),
          circle: this.circle,
          active: this.active,
        }];
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../../variables";
.wt-button {
  min-width: 120px;

  &.hollow-dark {
    &.active {
      background-color: rgba(black, .75);
      color: white;
      &:not(:disabled):hover {
        background-color: rgba(black, .95);
        color: white;
    }
  }
    background-color: transparent;
    font-size: $font-size-m;
    color: $color-normal;
    border: 1px solid $color-normal;

    &:not(:disabled) {
      &:hover {
        background-color: $color-black-l2;
        border-color: $color-black;
        color: $color-black;
    }
    //&:active {
    //  background-color: $color-black-l1;
    //}
  }
}

  &.hollow-light {
    background-color: transparent;
    font-size: $font-size-l;
    color: $color-white;
    border: 1px solid $color-white;

    &:not(:disabled) {
      &:hover {
        background-color: $color-black-l;
    }
    //&:active {
    //  background-color: $color-black-l1;
    //}
  }
}

  &.hollow-secondary {
    background-color: transparent;
    font-size: $font-size-n;
    color: $color-secondary;
    border: 1px solid $color-secondary;
    min-width: unset;

    i {
      font-size: $font-size-n;
  }
    &:not(:disabled):not(.-disabled){
      &:hover {
        background-color: $color-secondary;
        color: $color-white;
    }
  }
}
}
</style>
